import { useState } from "react";

import {
  IconButton,
  Stack,
  Text,
  TextInputField,
  useFieldArray,
  useFieldContext,
  useFieldRegister,
  useTheme
} from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { SelectorCreateRequestRule } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { Permissions } from "@libs/permissions/permissions.enum";

import { CommaSeparatedListValueCount } from "../dialogs/CommaSeparatedListValueCount";
import { EditListAttributeValueDialog } from "../dialogs/EditListAttributeValueDialog";

interface SelectorListTypeValueColumnProps {
  name: string;
  index: number;
}

export const SelectorListTypeValueColumn: React.FC<SelectorListTypeValueColumnProps> = ({
  name,
  index
}) => {
  const theme = useTheme();
  const ruleValueName = `${name}.value`;

  useFieldRegister(ruleValueName);
  const { value } = useFieldContext<string>(ruleValueName);
  const [showEditListValue, setShowEditListValue] = useState<boolean>(false);

  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementWrite
  );

  const { value: valueDataType } = useFieldContext<string>(
    `${name}.valueDataType`
  );

  const {
    actions: { update },
    value: rules
  } = useFieldArray<SelectorCreateRequestRule>("rules");

  if (valueDataType === "LIST") {
    return (
      <Stack
        tokens={{ childrenGap: theme.spacing.s1 }}
        styles={{ root: { flexGrow: 1, width: "100%" } }}
      >
        <Stack
          horizontal
          verticalAlign="center"
          tokens={{ childrenGap: theme.spacing.s1 }}
        >
          <Text
            styles={{
              root: {
                flexGrow: 1,
                width: "100%"
              }
            }}
            nowrap
          >
            {value}
          </Text>
          <IconButton
            iconProps={{ iconName: "Edit" }}
            styles={{ root: { width: "max-content" } }}
            onClick={() => setShowEditListValue(true)}
            disabled={!hasWritePermission}
          />
        </Stack>
        <CommaSeparatedListValueCount value={value} />
        {showEditListValue && (
          <EditListAttributeValueDialog
            rule={rules[index]}
            update={item => update(index, item)}
            onDismiss={() => setShowEditListValue(false)}
          />
        )}
      </Stack>
    );
  } else {
    return (
      <TextInputField
        name={ruleValueName}
        styles={{ root: { height: "100%" } }}
        required
      />
    );
  }
};
